export default __webpack_public_path__ + "static/cp-f28605dd81e51a89000b2b08b54fe5dd.webp";